import { DateTime } from "luxon";

export function isSameDay(a: DateTime, b: DateTime): boolean{
    return a.hasSame(b, "day") && a.hasSame(b, "month") && a.hasSame(b, "year")
}